import { jsonApiVuex } from '@common/store/json-api-vuex';

export const tmsWebRuleCategory = jsonApiVuex('tms/rule-category', {}, {});
